(ns minorodata.ai-chat.response
  (:require [clojure.string :as string]))


(defn strip-proposal-block [message]
  (-> (or message "")
      (string/replace #"<TRANSFORM_PROPOSAL>[\s\S]*?</TRANSFORM_PROPOSAL>" "")
      (string/replace #"<TRANSFORM_PROPOSAL>[\s\S]*$" "")
      string/trim))

(defn turns [messages]
  (partition-by #(= "user" (:author %)) messages))

(defn copy-text [turn]
  (->> turn
       (filter #(and (not= "user" (:author %))
                     (= "text" (:type %))))
       (keep #(not-empty (strip-proposal-block (:text %))))
       (string/join "\n\n")
       not-empty))
